import { inject } from "@angular/core";
import { Router } from "@angular/router";

import { hasPermissionGuard } from "../../core/guards";
import { AdaaHelper, isDsV2 } from "../../core/utils";
import { Constants } from "../../shared/constants/constants";
import { PermissionAction } from "../../shared/constants/enums";

export const viewTPDashboardPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.NATIONAL_PROJECTS_DASHBOARD,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const viewTransformationalProjectsPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.NATIONAL_PROJECTS,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageTransformationalProjectsPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.NATIONAL_PROJECTS,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const createTransformationalProjectsPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.create,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.NATIONAL_PROJECTS,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const viewTPMilestonePageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.NATIONAL_PROJECT_MILESTONES,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageTPMilestonePageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.NATIONAL_PROJECT_MILESTONES,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const viewTPCyclesPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.TP_CYCLES,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const createTPCyclesPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.create,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.TP_CYCLES,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageTPCyclesPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.TP_CYCLES,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const viewTTargetsPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.TRANSFORMATIONAL_TARGETS,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const createTTargetsPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.create,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.TRANSFORMATIONAL_TARGETS,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageTTargetsPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.TRANSFORMATIONAL_TARGETS,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const viewAgreementPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.TRANSFORMATIONAL_PROJECT_AGREEMENT,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const viewTPSubMenu = [
  hasPermissionGuard({
    actor: {
      modifier: "or",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.NATIONAL_PROJECTS,
        },
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.NATIONAL_PROJECT_MILESTONES,
        },
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.TP_CYCLES,
        },
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.TRANSFORMATIONAL_TARGETS,
        },
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.TRANSFORMATIONAL_PROJECT_AGREEMENT,
        },
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.MOKPI,
        },
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.MTKPI,
        },
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.IMKPI,
        },
      ],
    },
    redirectTo: "/403",
  }),
];
export const isExternalOrDs2 = () => {
  const router = inject(Router);

  const entityType = AdaaHelper.getLocalStorage(Constants.localStorageKeys.currentEntity, {
    type: "prop",
    property: "entityType",
  });

  const isExternalEntity =
    +entityType === Constants.ENTITY_TYPES.PARTICIPATING || +entityType === Constants.ENTITY_TYPES.EXTERNAL;

  return isExternalEntity || isDsV2() ? true : router.createUrlTree(["/403"]);
};
